<div class="container">
  <div class="close" (click)="closeDialog()">
    <img src="assets/icons/news/close.svg" alt="close modal" />
  </div>
  <h1 class="title">{{ data.title }}</h1>
  <form [formGroup]="formGroup" class="form">
    <app-reminder-message
      message="Recordá agregar cuentas a tu nombre y no cuentas de terceros."
      type="warning"
    >
    </app-reminder-message>
    <div class="selector">
      <p class="selector-title">Tipo de cuenta</p>
      <div class="choice">
        <div class="circle" [class.isActive]="currency === 1"></div>
        <div class="pill" (click)="changeCurrency(1)">
          <p [class.active]="currency === 1">AR$</p>
        </div>
        <div class="pill" (click)="changeCurrency(0)">
          <p class="option" [class.active]="currency !== 1">U$D</p>
        </div>
      </div>
    </div>

    <mat-form-field appearance="outline">
      <mat-label>CBU/CVU/ALIAS</mat-label>
      <input matInput name="cbu" formControlName="cbuControl" (change)="fillBankName()" />
      <mat-error
        for="cbu"
        *ngIf="
          (!formGroup.controls.cbuControl.pristine || formGroup.controls.cbuControl.touched) &&
          formGroup.controls.cbuControl.invalid
        "
      >
        {{ getErrorMessage('cbuControl') }}
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Nombre cuenta</mat-label>
      <input matInput type="text" name="description" formControlName="bankControl" />
      <mat-error
        for="description"
        class="form-error"
        *ngIf="
          (!formGroup.controls.bankControl.pristine || formGroup.controls.bankControl.touched) &&
          formGroup.controls.bankControl.invalid
        "
      >
        {{ getErrorMessage('bankControl') }}
      </mat-error>
    </mat-form-field>

    <button class="td-btn primary" (click)="addInformation()">Agregar</button>
  </form>
</div>
